import React, { FC } from 'react';
import { Chip, useTheme } from '@mui/material';
import { lighten, darken } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import tinycolor from 'tinycolor2';

import { IGroup } from '../../shared/interfaces/IGroup';

interface Props {
  tag: IGroup;
}

/** Displays a group tag chip. Clicking navigates to /monitoring/groups. */
const GroupTagChip: FC<Props> = ({ tag }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const bg = tag.color;
  const text = theme.palette.getContrastText(bg);
  const isLight = tinycolor(bg).isLight();
  const hoverBg = isLight ? darken(bg, 0.15) : lighten(bg, 0.25);

  return (
    <Chip
      label={tag.name}
      size="small"
      onClick={() => navigate('/monitoring/groups')}
      sx={{
        cursor: 'pointer',
        mr: 0.5,
        backgroundColor: bg,
        color: text,
        '&:hover': {
          backgroundColor: hoverBg,
        },
      }}
    />
  );
};

export default GroupTagChip;
